import { render } from "./Demos.vue?vue&type=template&id=ae845a36&scoped=true&ts=true"
import script from "./Demos.vue?vue&type=script&lang=ts"
export * from "./Demos.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae845a36"]])

export default __exports__